import Cookies from "js-cookie";

export const setToken = (token) => {
  if (token) {
    Cookies.set("adminToken", token, {
      expires: 7,
      path: "/",
      sameSite: "Lax",
    });
    try {
      localStorage.setItem("adminToken", token);
    } catch (e) {
      console.error("Error setting localStorage adminToken", e);
    }
  }
};

export const getToken = () => {
  const cookieToken = Cookies.get("adminToken");
  if (cookieToken) return cookieToken;
  try {
    return localStorage.getItem("adminToken") || null;
  } catch (e) {
    return null;
  }
};

export const removeToken = () => {
  Cookies.remove("adminToken", { path: "/" });
  try {
    localStorage.removeItem("adminToken");
  } catch (e) {}
};